<template>
    <v-dialog v-model="dialogEtiquetas" max-width="800px" scrollable>
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">
                Ver conteo de etiquetas por vendedor
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="headline grey lighten-2">
                Conteo de Etiquetas por Vendedor
            </v-card-title>

            <v-card-text class="pt-6">
                <v-data-table :headers="headers" :items="conteoPorVendedor" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :items-per-page="-1" class="elevation-1" dense>
                    <!-- Cabeceras personalizadas para que se vean bonitas -->
                    <template v-slot:headers="{ props }">
                        <tr>
                            <th v-for="header in props.headers" :key="header.text" class="text-center">
                                <span class="font-weight-bold">{{ header.text }}</span>
                            </th>
                        </tr>
                    </template>

                    <!-- Fila: Vendedor -->
                    <template v-slot:item.name="{ item }">
                        <strong>{{ item.name.toUpperCase() || 'Sin asignar' }}</strong>
                    </template>

                    <!-- Fila: Cada etiqueta con chip coloreado -->
                    <template v-for="etiqueta in etiquetas" v-slot:[`item.${etiqueta.idetiquetas}`]="{ item }">
                        <v-chip :key="etiqueta.idetiquetas" small color="primary" text-color="white"
                            class="font-weight-bold ma-1">
                            {{ item.conteos[etiqueta.idetiquetas] || 0 }}
                        </v-chip>
                    </template>

                    <!-- Fila: Total -->
                    <template v-slot:item.total="{ item }">
                        <v-chip color="primary" dark small>
                            <strong>{{ item.total }}</strong>
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" dark @click="descargarExcel" :loading="false">
                    <v-icon left>mdi-microsoft-excel</v-icon>
                    Descargar Excel
                </v-btn>
                <v-btn color="blue darken-1" text @click="closeDialog()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import XLSX from 'xlsx'
export default {
    props: {
        dialogEtiquetas: {
            type: Boolean,
            required: false,
            default: false
        },
        prospectos: {
            type: Array,
            required: true,
            default: () => []
        },
    },

    data() {
        return {
            dialog: false,
            sortBy: 'total',
            sortDesc: true,
            etiquetas: [
                { idetiquetas: 1, text: 'PENDIENTE DE PAGO', color: '#FF0000' },
                { idetiquetas: 2, text: 'CLIENTE POTENCIAL', color: '#FFD700' },
                { idetiquetas: 3, text: 'EXAMEN DE UBICACION', color: '#1E90FF' },
                { idetiquetas: 4, text: 'PAGO PARCIAL', color: '#FF6D08' },
                { idetiquetas: 5, text: 'INSCRITO', color: '#48D91C' },
                { idetiquetas: 6, text: 'VENTANA DE TIEMPO', color: '#4A148C' },
                { idetiquetas: 7, text: 'SPAM', color: '#000000' },
                { idetiquetas: 8, text: 'CON CITA AGENDADA', color: '#F40BD8' },
                { idetiquetas: 9, text: 'CLIENTE NO CONTESTA', color: '#F40BD8' },
                { idetiquetas: 10, text: 'NO INTERESADO', color: '#F40BD8' },
                { idetiquetas: 11, text: 'EXAMEN ENVIADO', color: '#F40BD8' },
                { idetiquetas: 12, text: 'NUEVO', color: '#F40BD8' },
                { idetiquetas: 13, text: 'PRIMER CONTACTO', color: '#F40BD8' },
                { idetiquetas: 14, text: 'LLAMADA AGENDADA', color: '#F40BD8' },
                { idetiquetas: 15, text: 'NUEVO WEB', color: '#F40BD8' },
            ],
        }
    },

    computed: {
        headers() {
            const headers = [
                { text: 'Vendedor', value: 'name', width: '180px', fixed: true }
            ]

            // Añadir una columna por cada etiqueta
            // Columna total
            headers.push({
                text: 'Total',
                value: 'total',
                align: 'center',
                width: '100px'
            })
            this.etiquetas.forEach(et => {
                headers.push({
                    text: et.text,
                    value: et.idetiquetas.toString(),
                    align: 'center',
                    width: '120px'
                })
            })


            return headers
        },

        conteoPorVendedor() {
            const mapa = {}

            // Recorrer todos los prospectos
            this.prospectos.forEach(prospecto => {
                const vendedor = prospecto.name || 'Sin asignar'
                const idEtiqueta = prospecto.idetiquetas

                if (!mapa[vendedor]) {
                    mapa[vendedor] = {
                        name: vendedor,
                        conteos: {},
                        total: 0
                    }
                }
                // Contar etiqueta
                mapa[vendedor].conteos[idEtiqueta] = (mapa[vendedor].conteos[idEtiqueta] || 0) + 1
                mapa[vendedor].total += 1
            })

            // Convertir a array
            return Object.values(mapa).sort((a, b) => b.total - a.total) // Ordenar por total descendente
        }
    },

    methods: {
        closeDialog() {
            this.$emit("closeDialogEtiquetas")
        },
        descargarExcel() {
            // 1. Preparar los datos en formato plano para Excel
            const datosParaExcel = []

            this.conteoPorVendedor.forEach(vendedor => {
                const fila = {
                    Vendedor: vendedor.name || 'Sin asignar',
                }

                // Agregar columna por cada etiqueta
                this.etiquetas.forEach(et => {
                    fila[et.text] = vendedor.conteos[et.idetiquetas] || 0
                })

                // Total
                fila['Total Prospectos'] = vendedor.total

                datosParaExcel.push(fila)
            })

            // 2. Crear hoja de trabajo
            const ws = XLSX.utils.json_to_sheet(datosParaExcel)

            // 3. Ajustar ancho de columnas (opcional pero recomendado)
            const colWidths = [
                { wch: 30 }, // Vendedor
                ...this.etiquetas.map(() => ({ wch: 18 })), // Etiquetas
                { wch: 15 } // Total
            ]
            ws['!cols'] = colWidths

            // 4. Crear libro y agregar hoja
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Conteo Etiquetas')

            // 5. Generar y descargar el archivo
            const nombreArchivo = `conteo_etiquetas_por_vendedor_${new Date().toISOString().slice(0, 10)}.xlsx`
            XLSX.writeFile(wb, nombreArchivo)
        },
    }
}
</script>

<style scoped>
.v-data-table>>>th {
    font-size: 13px !important;
}
</style>